var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 20,
    viewBox: "0 0 9 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C6.73478 0 6.48043 0.105357 6.29289 0.292893C6.10536 0.48043 6 0.734784 6 1V4H2C0.89 4 0 4.89 0 6V18C0 19.11 0.89 20 2 20H7C8.11 20 9 19.11 9 18V6C9 5.26 8.6 4.62 8 4.28V1C8 0.734784 7.89464 0.48043 7.70711 0.292893C7.51957 0.105357 7.26522 0 7 0ZM2 6H7V11H2V6ZM2 13H3V14H2V13ZM4 13H5V14H4V13ZM6 13H7V14H6V13ZM2 15H3V16H2V15ZM4 15H5V16H4V15ZM6 15H7V16H6V15ZM2 17H3V18H2V17ZM4 17H5V18H4V17ZM6 17H7V18H6V17Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellphone);
export default __webpack_public_path__ + "static/media/Cellphone.a6978fbed1d2637248432c0b262c832e.svg";
export { ForwardRef as ReactComponent };